import React, { useRef } from "react";
import { DEFAULT_TARGET } from "@constants";
import { useAppStore } from "@store/appStore";
import {
  EMessageActionType,
  IMessageAction,
  IQuickReply,
  IQuickReplyItem,
} from "@types";
import { createDataAttr } from "@utils";
import { shallow } from "zustand/shallow";

const QuickReply = ({
  quickReply,
  onSendAction,
}: {
  quickReply?: IQuickReply;
  onSendAction: (action: IMessageAction) => Promise<void>;
}) => {
  const footerRef = useRef<HTMLDivElement>(null);
  const { linkTarget = DEFAULT_TARGET } = useAppStore((state) => {
    return {
      linkTarget: state.settings.linkTarget,
    };
  }, shallow);

  const onQuickReplyClick = (action: IMessageAction) => {
    onSendAction(action);
  };

  if (!quickReply) return <></>;
  return (
    <div
      className="flex flex-nowrap gap-4 overflow-auto pl-14"
      style={{
        width: window.innerWidth - 16,
      }}
      ref={footerRef}
      {...createDataAttr("quick-reply")}
    >
      {quickReply.items.map((item: IQuickReplyItem) => {
        if (item.action.type === EMessageActionType.URI_ACTION) {
          return (
            <a
              key={item.action.id}
              href={item.action.uri}
              target={linkTarget}
              className="mb-2 mt-2 whitespace-nowrap rounded-full border-transparent bg-white px-4 py-2 font-bold "
              {...createDataAttr("quick-button")}
            >
              {item.action.label}
            </a>
          );
        }

        return (
          <button
            key={item.action.id}
            onClick={() => onQuickReplyClick(item.action)}
            className="mb-2 mt-2 whitespace-nowrap rounded-full border-transparent bg-white px-4 py-2 font-bold"
            {...createDataAttr("quick-button")}
          >
            {item.action.label}
          </button>
        );
      })}
    </div>
  );
};

export default QuickReply;
